export default __webpack_public_path__ + "static/media/x-mark.cc77b84b.png";